import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelRadio as _vModelRadio, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-test", "data-testid"]
const _hoisted_2 = ["id", "name", "value", "disabled"]
const _hoisted_3 = ["aria-checked", "aria-disabled", "aria-labelledby"]
const _hoisted_4 = {
  key: 0,
  class: "ds-radio__texts"
}
const _hoisted_5 = ["data-test", "id"]
const _hoisted_6 = ["data-test"]

import { computed, useAttrs } from "vue";
import type { Theme } from "../../types/theme";
import { DsFormFieldValueType } from "../models/ds-form-field-models";
import { DsRadioOptionModel } from "./ds-radio/ds-radio-models";


export default /*@__PURE__*/_defineComponent({
  ...{ inheritAttrs: false },
  __name: 'ds-radio',
  props: /*@__PURE__*/_mergeModels({
    value: {},
    label: {},
    supportingText: {},
    disabled: { type: Boolean },
    dataTestLabel: {},
    dataTestText: {},
    dataTestDescription: {},
    id: {},
    name: {},
    theme: {},
    dataTestid: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props;


const { class: wrapperClass, ...attrs } = useAttrs();

const modelValue = _useModel<T>(__props, "modelValue");

const radioKeydownEventHandler = (event: KeyboardEvent) => {
    if (!props.disabled && (event.key === "Enter" || event.key === "Space")) {
        modelValue.value = props.value;
    }
};

const ariaLabelId = computed(() => `label-${props.id.replace(/\s+/g, "-").toLowerCase()}`);

const isChecked = computed(() => modelValue.value == props.value);

const rootClasses = computed(() => {
    return [
        props.theme === "dark" ? "theme--dark" : "",
        props.disabled ? "disabled" : "",
        isChecked.value ? "checked" : "",
    ];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass(["ds-radio", [_unref(wrapperClass), rootClasses.value]]),
    "data-test": _ctx.dataTestLabel,
    "data-testid": _ctx.dataTestid
  }, [
    _withDirectives(_createElementVNode("input", _mergeProps({
      type: "radio",
      class: "ds-radio__input",
      id: _ctx.id,
      name: _ctx.name,
      value: _ctx.value,
      disabled: _ctx.disabled,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event))
    }, attrs), null, 16, _hoisted_2), [
      [_vModelRadio, modelValue.value]
    ]),
    _createElementVNode("div", {
      class: "ds-radio__radio",
      tabindex: "0",
      onKeydown: radioKeydownEventHandler,
      role: "radio",
      "aria-checked": isChecked.value,
      "aria-disabled": _ctx.disabled,
      "aria-labelledby": ariaLabelId.value
    }, null, 40, _hoisted_3),
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("span", {
            class: "ds-radio__label",
            "data-test": _ctx.dataTestText,
            id: ariaLabelId.value
          }, _toDisplayString(_ctx.label), 9, _hoisted_5),
          (_ctx.supportingText)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "ds-radio__message",
                "data-test": _ctx.dataTestDescription
              }, _toDisplayString(_ctx.supportingText), 9, _hoisted_6))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}
}

})